import React from "react";
import cx from "classnames";
import dayjs from "dayjs";
import { useHistory } from "react-router";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { compact, isEmpty, noop } from "lodash";
import { useQueryParam } from "hooks/useQueryParam";
// eslint-disable-next-line no-restricted-imports
import {
  getNextAvailableDate,
  getPreviousScheduleDate,
  getScheduleDays,
  updateQueryParam,
} from "../utils/calendarWeek";
import stylesV2 from "./WeekTimeSlots.module.scss";
import stylesV3 from "./WeekTimeSlotsV2.module.scss";
import { RootState } from "app/store";
import { NavigationButton } from "features/scheduling/AppointmentSelectSlot/NavigationButton";
import { Office } from "types/office";
import { Doctor } from "types/doctor";
import { Slot } from "types/slot";
import { API_DATE_FORMAT } from "api/constants";
import { WaitlistV2 } from "features/scheduling/components/Waitlist/WaitlistV2";
import { FeatureOffice } from "features/scheduling/components/FeatureOfficeBanner";
import { DoctorSelectionPanelV2 } from "features/scheduling/components/DoctorSelectionPanelV2";
import { selectDoctorOrderedByAvailability } from "features/scheduling/availabilitySummarySlice";
import {
  setTimeSlots,
  selectIstimeSlotLoaded,
  selectTimeslots,
} from "features/scheduling/timeSlotsSlice";
import chevronDownIcon from "images/chevron-downV2.svg";
import chevronUpIcon from "images/chevron-upV2.svg";
import { useTrackEvent } from "hooks/useTrackEvent";
import { FirstAvailSlot } from "features/scheduling/FirstAvailSlot";
import { useSchedulingABVariant } from "../utils/useSchedulingABVariant";

interface OfficeCardProps {
  office: Office;
  featureOffice: Office | null;
  showFeatureOffice: boolean;
  doctors: Doctor[];
  searchDate: string;
  onSelection: (type: string, value: Slot) => void;
  seeMoreScrollToTop: (visible: boolean) => void;
  setTimeslotsExecution: () => void;
  selectedSlot: undefined | Slot;
  isEditForm: false;
  newDateArr: any;
  pageSection: string;
  newDesign: string | null;
  slotMetaData: any[];
  screenSize: number;
  firstAvailDocs: any;
  useClassicStartLayout?: boolean;
  headerContent?: React.ReactNode;
  hideHeading?: boolean;
  enableMobileDateScroller?: boolean;
  isMobileView?: boolean;
  onNextMobile?: () => void;
}

export const WeekTimeSlots: React.FC<OfficeCardProps> = ({
  office,
  featureOffice,
  showFeatureOffice,
  doctors,
  searchDate,
  onSelection,
  seeMoreScrollToTop,
  setTimeslotsExecution,
  selectedSlot,
  isEditForm,
  newDateArr,
  pageSection,
  newDesign,
  slotMetaData,
  screenSize,
  firstAvailDocs,
  useClassicStartLayout = false,
  headerContent,
  hideHeading = false,
  enableMobileDateScroller = false,
  isMobileView = false,
  onNextMobile,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { trackEvent } = useTrackEvent();
  const [firstAvail, setFirstAvail] = useQueryParam("firstAvail", false);
  const [visible, setVisible] = React.useState(false);
  const [executeOnce, setExecuteOnce] = React.useState(false);
  const [loadOnce, setLoadOnce] = React.useState(false);
  const [openWaitlist, setOpenWaitlist] = React.useState(false);
  const [selectedDate, setSelectedDate] = React.useState<undefined | string>(
    undefined
  );
  const [prevWeek, setPrevWeek] = React.useState<string>("");
  const [nextWeek, setNextWeek] = React.useState<string>("");
  const selectedDateTemp =
  selectedDate === undefined ? searchDate : selectedDate;
  const [firstSlot, setFirstSlot] = React.useState<any>(null);
  const { isV3 } = useSchedulingABVariant();
  const styles =
    isV3 && !useClassicStartLayout ? stylesV3 : stylesV2;
  /*
  const doctorIdsByAvailability = useSelector(
    (state: RootState) =>
      selectDoctorOrderedByAvailability(
        state,
        office.id,
        selectedDateTemp,
        office.timeSlotWeeks
      ),
    shallowEqual
  );

  const newSortedDoctors = compact(
    doctorIdsByAvailability.map((doctorId) => {
      return doctors.find((doctor) => doctor.id === doctorId);
    })
  ); */
  const visibleDayCount = enableMobileDateScroller && isMobileView ? 5 : 7;
  const weekCalendar = React.useMemo(
    () =>
      Array.from({ length: visibleDayCount }, (_, index) =>
        dayjs(searchDate).add(index, "day").format(API_DATE_FORMAT)
      ),
    [searchDate, visibleDayCount]
  );

  const isSlotLoaded = useSelector((state: RootState) =>
    selectIstimeSlotLoaded(state)
  );
  const newDateRange = getScheduleDays();

  
  React.useEffect(() => {
    if(firstAvail &&
      firstAvail === "true" &&
      firstAvailDocs &&
      Object.keys(firstAvailDocs).length > 0) {
      const sort_first_Array = []
      for(const doc in firstAvailDocs) {
        sort_first_Array.push(firstAvailDocs[doc]);
      }
      const sortFirstAvail = [...sort_first_Array].sort((a, b) => dayjs(a.date +" "+ a.startTime) - dayjs(b.date +" "+ b.startTime));
      setFirstSlot(sortFirstAvail[0]); 
      
    }
  },[firstAvailDocs]);

  let newSortedDoctor = [];
  let totalSlotCount = 0;
  if (doctors.length > 1) {
    newSortedDoctor = [doctors].sort(function (a, b) {
      const textA = a.lastName.toUpperCase();
      const textB = b.lastName.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
  if (isSlotLoaded) {
    if (!isEmpty(newDateArr) && pageSection === "TIMESLOT") {
      const doctorIds = [];

      for (let i = 0; i < doctors.length; i++) {
        doctorIds.push(doctors[i]["id"]);
      }
      const dateNotAvailArr = {};
      for (const key in newDateRange) {
        const doctorNotimeslot = {};
        let doctorNotimeslotArr = {};
        dateNotAvailArr[key] = {};
        if (typeof newDateArr[key] === "undefined") {
          for (let i = 0; i < doctorIds.length; i++) {
            const returnData = getNextAvailableDate(
              doctorIds[i],
              key,
              newDateArr,
              newDateRange
            );
            //console.log(doctorIds[i],key);
            //console.log(returnData);
            doctorNotimeslot[doctorIds[i]] = returnData; //getAvailableDate(doctorIds[i],key,newDateArr);
            doctorNotimeslotArr = { doctorID: doctorIds[i], count: returnData };
            //console.log(doctorNotimeslot[key]);
          }
        } else {
          for (let i = 0; i < doctorIds.length; i++) {
            //console.log(doctorIds[i],key);
            if (typeof newDateArr[key][doctorIds[i]] === "undefined") {
              const returnData = getNextAvailableDate(
                doctorIds[i],
                key,
                newDateArr,
                newDateRange
              );
              //console.log(returnData);
              doctorNotimeslot[doctorIds[i]] = returnData; //getAvailableDate(doctorIds[i],key,newDateArr);
              doctorNotimeslotArr = {
                doctorID: doctorIds[i],
                count: returnData,
              };
            }
          }
        }
        dateNotAvailArr[key] = doctorNotimeslot;
      }
      //console.log(dateNotAvailArr);
      const newDoctorAvailables = [];

      for (const availDoctor in newDateArr[selectedDateTemp]) {
        const doctorMatch = doctors.find((doctor) => doctor.id === availDoctor);
        if (!doctorMatch) continue;
        const tempDoc = { ...doctorMatch };
        tempDoc.count = newDateArr[selectedDateTemp][availDoctor][0];
        totalSlotCount =
          totalSlotCount + newDateArr[selectedDateTemp][availDoctor][0];
        newDoctorAvailables.push(Object.preventExtensions(tempDoc));
      }
      newDoctorAvailables.sort((a, b) => {
        if (a.count === b.count) {
          const textA = a.lastName.toUpperCase();
          const textB = b.lastName.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return b.count - a.count;
        }
      });
      const newDoctorNextAvailables = [];
      const limitedDoctor = [];
      for (const availDoctor in dateNotAvailArr[selectedDateTemp]) {
        const nextAvailDoctor = dateNotAvailArr[selectedDateTemp][availDoctor];
        if (nextAvailDoctor[1] === "nextavailable") {
          const doctorMatch = doctors.find(
            (doctor) => doctor.id === availDoctor
          );
          if (!doctorMatch) continue;
          const tempDoc = { ...doctorMatch };
          tempDoc.count = nextAvailDoctor[0];
          tempDoc.date = nextAvailDoctor[2];
          newDoctorNextAvailables.push(Object.preventExtensions(tempDoc));
        }
        if (nextAvailDoctor[1] == "") {
          limitedDoctor.push(availDoctor);
        }
      }
      /*
  newDoctorNextAvailables.sort((a, b) => {
    if (a.date === b.date) {
      if (a.count === b.count) {
        const textA = a.lastName.toUpperCase();
        const textB = b.lastName.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      } else {
        return b.count - a.count;
      }
    } else if (a.date !== b.date) {
      return new Date(a.date) - new Date(b.date);
    } else {
      return b.count - a.count;
    }
  }); */
      newDoctorNextAvailables.sort((a, b) => {
        const textA = a.lastName.toUpperCase();
        const textB = b.lastName.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      const limitedDoctorList = [];
      for (const avail of limitedDoctor) {
        limitedDoctorList.push(doctors.find((doctor) => doctor.id === avail));
      }

      limitedDoctorList.sort(function (a, b) {
        const textA = a.lastName.toUpperCase();
        const textB = b.lastName.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });

      const avalDocids = newDoctorAvailables.map((item) => item.id);
      const avalNextDocids = newDoctorNextAvailables.map((item) => item.id);
      const limitedDocids = limitedDoctorList.map((item) => item.id);
      newSortedDoctor = [];
      for (const avail of avalDocids) {
        newSortedDoctor.push(doctors.find((doctor) => doctor.id === avail));
      }
      for (const avail of avalNextDocids) {
        newSortedDoctor.push(doctors.find((doctor) => doctor.id === avail));
      }
      for (const avail of limitedDocids) {
        newSortedDoctor.push(doctors.find((doctor) => doctor.id === avail));
      }
    }
  }
  const doctorsToDisplay =
    newSortedDoctor.length === doctors.length ? newSortedDoctor : doctors;
  // const doctorsToDisplay = newSortedDoctors || doctors;

  const onSelectFullView = () => {
    setVisible(!visible);
    seeMoreScrollToTop(visible);
  };
  
  const onSelectionfirstSlot = (slot: any) => {
    if (
      slot &&
      dayjs(slot.date) > dayjs().add(visibleDayCount - 1, "day")
    ) {
      onSelectDate(slot.date);
    }
    onSelection("firstAvail", slot);
  };
  
  const onSelectDate = (date: string) => {
    if (weekCalendar.length > 0 && weekCalendar.indexOf(date) > -1) {
      setSelectedDate(date);
    } else {
      const params = new URLSearchParams(history.location.search);
      params.set("date", date);
      setExecuteOnce(false);
      setTimeslotsExecution();
      setSelectedDate(date);
      setLoadOnce(false);
      history.replace({ search: params.toString() });
    }
  };

  const onSetLoadOnce = () => {
    if (!loadOnce) setLoadOnce(true);
  };

  const onSelectWaitlist = () => {
    setOpenWaitlist(!openWaitlist);
  };

  const seeMoreText = visible
    ? "See less doctors in this office "
    : "See more doctors in this office ";
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const trackBrowseDatesEvent = (direction: "left" | "right") => () => {
    const lastCalendarDay = weekCalendar[weekCalendar.length - 1];
    const browseDate =
      direction === "left"
        ? getPreviousScheduleDate(weekCalendar[0], visibleDayCount)
        : dayjs(lastCalendarDay).add(1, "day").format(API_DATE_FORMAT);

    setExecuteOnce(false);
    setLoadOnce(false);
    setSelectedDate(browseDate);
  };
  React.useEffect(() => {
    if (weekCalendar.length === visibleDayCount && !executeOnce) {
      if (!dayjs(weekCalendar[0]).isAfter(dayjs(), "day")) {
        setPrevWeek("");
      } else {
        setPrevWeek(
          updateQueryParam(
            "date",
            getPreviousScheduleDate(weekCalendar[0], visibleDayCount)
          )
        );
      }
      const today = dayjs().format(API_DATE_FORMAT);
      const restrictDate = 7 * office.timeSlotWeeks;
      const restrictedDay = dayjs(today)
        .add(restrictDate, "day")
        .format(API_DATE_FORMAT);
      const lastCalendarDay = weekCalendar[weekCalendar.length - 1];
      if (dayjs(lastCalendarDay).isBefore(restrictedDay)) {
        setNextWeek(
          updateQueryParam(
            "date",
            dayjs(lastCalendarDay).add(1, "day").format(API_DATE_FORMAT)
          )
        );
      } else {
        setNextWeek("");
      }
      setExecuteOnce(true);
    }
  }, [
    executeOnce,
    history,
    office.timeSlotWeeks,
    selectedDateTemp,
    visibleDayCount,
    weekCalendar,
  ]);

  React.useEffect(() => {
    if (screenSize >= 992) {
      if (
        !isEmpty(slotMetaData) &&
        totalSlotCount > 0 &&
        slotMetaData[selectedDateTemp] &&
        !isEmpty(slotMetaData[selectedDateTemp])
      ) {
        const searchDateSlots = slotMetaData[selectedDateTemp];
        trackEvent("slotsLoaded", {
          totalSlotCount: searchDateSlots.total_slots,
          hiddenSlotCount: searchDateSlots.hide_slots,
          visibleSlotCount: searchDateSlots.visible_slots,
          rslBypass: true,
          location: office.id,
          logicalId: office.logicalId,
        });
      }
      if (
        isSlotLoaded &&
        !isEmpty(newDateArr) &&
        totalSlotCount > 0 &&
        pageSection === "TIMESLOT" &&
        isEmpty(slotMetaData)
      ) {
        trackEvent("slotsLoaded", {
          totalSlotCount: totalSlotCount,
          hiddenSlotCount: 0,
          visibleSlotCount: totalSlotCount,
          rslBypass: false,
          location: office.id,
          logicalId: office.logicalId,
        });
      }
    }
  }, [
    trackEvent,
    slotMetaData,
    selectedDateTemp,
    screenSize,
    totalSlotCount,
    isSlotLoaded,
    newDateArr,
    pageSection,
    searchDate,
  ]);

  React.useEffect(() => {
    if (isEditForm) {
      if (selectedSlot) setSelectedDate(selectedSlot.date);
    }
  }, [isEditForm, selectedSlot]);

  const calendarDays = weekCalendar.map((day) => (
    <div
      key={day}
      className={
        selectedDateTemp === day
          ? cx(styles.dayContainer, styles.daySelected)
          : styles.dayContainer
      }
      onClick={() => onSelectDate(day)}
      aria-hidden="true"
    >
      <div className={styles.dayWords}>{dayjs(day).format("ddd")}</div>
      <div className={styles.monthYear}>
        {dayjs(day).format("MMM")} {dayjs(day).format("D")}
      </div>
    </div>
  ));

  return (
    <div
      className={cx(styles.container, {
        [styles.mobileDateScroller]:
          enableMobileDateScroller && isMobileView,
      })}
    >
      {headerContent}
      <div className={styles.datePickerBand}>
        {!hideHeading && (
          <>
            <h1 className={styles.headline}>
              {isV3 || useClassicStartLayout
                ? "Select doctor and time slot"
                : "SELECT DOCTOR AND TIME SLOT"}
            </h1>
            <hr className={styles.divider} />
          </>
        )}
        <div className={styles.weekContainer}>
          <div className={cx(styles.arrow, styles.arrowLeft)}>
            <NavigationButton
              url={prevWeek}
              disabled={prevWeek === "" || !isSlotLoaded}
              direction="left"
              onClick={trackBrowseDatesEvent("left")}
            />
          </div>
          {isV3 && !useClassicStartLayout ? (
            <div className={styles.daysViewport}>
              <div className={styles.daysRow}>{calendarDays}</div>
            </div>
          ) : (
            <div className={styles.daysRow}>{calendarDays}</div>
          )}
          <div className={cx(styles.arrow, styles.arrowRight)}>
            <NavigationButton
              url={nextWeek}
              disabled={nextWeek === "" || !isSlotLoaded}
              direction="right"
              onClick={trackBrowseDatesEvent("right")}
            />
          </div>
        </div>
      </div>
      {newDesign && showFeatureOffice && featureOffice && (
        <FeatureOffice
          featureOffice={featureOffice}
          isMobile={isMobileView}
        />
      )}
      {firstAvail && firstAvail === "true" && firstSlot && (
        <FirstAvailSlot onSelection={onSelectionfirstSlot} slot={firstSlot} />
      )}
      {doctorsToDisplay && (
        <DoctorSelectionPanelV2
          doctors={doctorsToDisplay}
          selectedOffice={office}
          forDate={selectedDateTemp}
          visible={visible}
          onSelection={onSelection}
          onSelectNextAvail={onSelectDate}
          selectedSlot={selectedSlot}
          weekCalendar={weekCalendar}
          loadOnce={loadOnce}
          onSetLoadOnce={onSetLoadOnce}
          onSelectWaitlist={onSelectWaitlist}
          newDateArr={newDateArr}
          useClassicStartLayout={useClassicStartLayout}
          isMobileView={isMobileView}
          onNextMobile={onNextMobile}
        />
      )}
      {doctorsToDisplay.length === 1 && !isMobileView && (
        <div className={styles.emptyHeight}></div>
      )}
      {doctorsToDisplay.length > 4 && !isMobileView && (
        <div
          className={styles.seeMore}
          onClick={() => onSelectFullView()}
          aria-hidden="true"
        >
          {seeMoreText}
          <img
            src={visible ? chevronUpIcon : chevronDownIcon}
            alt={seeMoreText}
          />
        </div>
      )}
      {!isMobileView && (
        <div className={styles.seeMoreWaitlist}>
          <div className={styles.underLine}></div>
          <WaitlistV2
            office={office}
            openWaitlist={openWaitlist}
            onSelectWaitlist={onSelectWaitlist}
          />
        </div>
      )}
    </div>
  );
};
